import axios from "axios"
import { ApiRequest } from "./api-request"
import { ApiMethods, ERROR_MESSAGE } from "../utils/constants"
import { ApiPaths } from "../utils/apiConstants"

export async function uploadFiles(formData) {
  console.log("formData", formData)
  const headers = {
    "Content-Type": "multipart/form-data",
  }

  try {
    const response = await ApiRequest({
      // url: "user/forgotPassword",
      url: ApiPaths.FILE_UPLOAD_MULTI,
      method: ApiMethods.POST,
      data: formData,
      headers,
    })

    // const response = await axios({
    //     url: ApiPaths.FILE_UPLOAD_MULTI,  // Replace with your actual API endpoint
    //     method: 'POST',
    //     data: formData,  // Pass the FormData as the body
    //     headers: {
    //         'Content-Type': 'multipart/form-data',  // This ensures proper content type for file upload
    //     },
    // });

    const result = response.data // Axios response will automatically parse JSON data
    return result
  } catch (error) {
    console.error("Error uploading files:", error)
    return {
      error: error.response
        ? error.response.data
        : "An error occurred during the file upload.",
    }
  }
}

export async function uploadFiles1(formData) {
  console.log("formData", formData)
  try {
    const headers = {
      "Content-Type": "multipart/form-data",
    }

    const response = await ApiRequest({
      // url: "user/forgotPassword",
      url: ApiPaths.FILE_UPLOAD_MULTI,
      method: ApiMethods.POST,
      body: formData,
      headers,
    })
    const result = response.data
    return result
  } catch (error) {
    return error
  }
}

export async function deleteFiles(data) {
  try {
    const response = await ApiRequest({
      url: "/storage/delete/files",
      method: ApiMethods.DELETE,
      data: data,
    })
    const result = response.data
    return result
  } catch (error) {
    return error
  }
}

export async function uploadImages(formData) {
  const headers = {
    "Content-Type": "multipart/form-data",
  }

  try {
    const response = await ApiRequest({
      url: ApiPaths.FILE_UPLOAD_IMAGES,
      method: ApiMethods.POST,
      data: formData,
      headers,
    })
    const result = response.data
    return result
  } catch (error) {
    console.error("Error uploading files:", error)
    return {
      error: error.response
        ? error.response.data
        : "An error occurred during the file upload.",
    }
  }
}

export async function uploadPdfs(formData) {
  const headers = {
    "Content-Type": "multipart/form-data",
  }

  try {
    const response = await ApiRequest({
      url: ApiPaths.FILE_UPLOAD_PDFS,
      method: ApiMethods.POST,
      data: formData,
      headers,
    })
    const result = response.data
    return result
  } catch (error) {
    console.error("Error uploading files:", error)
    return {
      error: error.response
        ? error.response.data
        : "An error occurred during the file upload.",
    }
  }
}

export async function deleteImage(fileName) {
  try {
    const response = await ApiRequest({
      url: `/storage/delete/${fileName}`,
      method: ApiMethods.DELETE,
    })
    const result = response.data
    return result
  } catch (error) {
    return error
  }
}